import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AILoaderIllustration = ({
  width,
  height
}) => /*#__PURE__*/_jsxs("svg", {
  id: "eEanjPXG5Hi1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60",
  height: height,
  width: width,
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  children: [/*#__PURE__*/_jsxs("defs", {
    children: [/*#__PURE__*/_jsxs("linearGradient", {
      id: "eEanjPXG5Hi2-fill",
      x1: "0.722363",
      y1: "0.117102",
      x2: "1.413995",
      y2: "0.87242",
      spreadMethod: "pad",
      gradientUnits: "objectBoundingBox",
      gradientTransform: "translate(0 0)",
      children: [/*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi2-fill-0",
        offset: "0%",
        stopColor: "#fb31a7"
      }), /*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi2-fill-1",
        offset: "51%",
        stopColor: "#ff4800"
      }), /*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi2-fill-2",
        offset: "100%",
        stopColor: "#fbddd2"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "eEanjPXG5Hi2-fill-g1",
      x1: "0.722363",
      y1: "0.117102",
      x2: "1.413995",
      y2: "0.87242",
      spreadMethod: "pad",
      gradientUnits: "objectBoundingBox",
      gradientTransform: "translate(0 0)",
      children: [/*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi2-fill-g1-0",
        offset: "0%",
        stopColor: "#fb31a7"
      }), /*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi2-fill-g1-1",
        offset: "51%",
        stopColor: "#ff4800"
      }), /*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi2-fill-g1-2",
        offset: "100%",
        stopColor: "#fbddd2"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "eEanjPXG5Hi3-fill",
      x1: "-0.176871",
      y1: "-0.254346",
      x2: "1",
      y2: "1",
      spreadMethod: "pad",
      gradientUnits: "objectBoundingBox",
      gradientTransform: "translate(0 0)",
      children: [/*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi3-fill-0",
        offset: "0%",
        stopColor: "#fb31a7"
      }), /*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi3-fill-1",
        offset: "50%",
        stopColor: "#ff4800"
      }), /*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi3-fill-2",
        offset: "100%",
        stopColor: "#fbddd2"
      })]
    }), /*#__PURE__*/_jsxs("linearGradient", {
      id: "eEanjPXG5Hi3-fill-g1",
      x1: "-0.176871",
      y1: "-0.254346",
      x2: "1",
      y2: "1",
      spreadMethod: "pad",
      gradientUnits: "objectBoundingBox",
      gradientTransform: "translate(0 0)",
      children: [/*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi3-fill-g1-0",
        offset: "0%",
        stopColor: "#fb31a7"
      }), /*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi3-fill-g1-1",
        offset: "50%",
        stopColor: "#ff4800"
      }), /*#__PURE__*/_jsx("stop", {
        id: "eEanjPXG5Hi3-fill-g1-2",
        offset: "100%",
        stopColor: "#fbddd2"
      })]
    })]
  }), /*#__PURE__*/_jsx("path", {
    id: "eEanjPXG5Hi2",
    d: "M31.82472,27.657282c0,0,0-11.764972,0-25.86574C31.82472,0.816206,30.9936,0,30,0c-1.00644,0-1.82472.803428-1.82472,1.79153c0,14.1009-11.99064,25.865752-26.3505,25.865752C0.815902,27.657282,0,28.460714,0,29.44874v.0024c0,.990546.815902,1.791578,1.82478,1.791578c14.35962,0,26.3505,11.764972,26.3505,25.865704C28.17528,58.083726,29.0064,58.9,30,58.9c1.00644,0,1.82472-.803432,1.82472-1.791578c0-14.100852,0-26.762063,0-26.762063s0,0,0,0v-2.689077c0,0,0,0,0,0Z",
    fill: "url(#eEanjPXG5Hi2-fill)"
  }), /*#__PURE__*/_jsx("path", {
    id: "eEanjPXG5Hi3",
    d: "M29.08764,13.828641c-7.17984,0-13.17528-5.882486-13.17528-12.93287C15.91236,0.408103,15.4968,0,15,0c-.50322,0-.91236.401714-.91236.895765c0,7.05045-5.99532,12.932876-13.17525,12.932876-.504439,0-.91239.401716-.91239.895729v.0012c0,.495273.407951.895789.91239.895789c7.17981,0,13.17525,5.882486,13.17525,12.932852c0,.487652.41556.895789.91236.895789.50322,0,.91236-.401716.91236-.895789c0-7.050426,5.99526-12.932852,13.17528-12.932852.50442,0,.91236-.401716.91236-.895789v-.0012c0-.495213-.40794-.895729-.91236-.895729Z",
    transform: "translate(30 14.725)",
    fill: "url(#eEanjPXG5Hi3-fill)"
  })]
});